__turbopack_context__.v({
  "weekendWarning": "wLMJaW_weekendWarning",
});
